import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M3 17h18v2H3zm16-5v1H5v-1h14m2-2H3v5h18v-5zM3 6h18v2H3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 12h14v1H5z",
  opacity: ".3"
})), 'CalendarViewDayTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CalendarViewDayTwoTone.js
// module id = 2587
// module chunks = 2